function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.4 32.721a.825.825 0 01.322-1.12l38.485-21.333a.825.825 0 011.121.321l14.048 25.342c.22.398.077.9-.322 1.121L20.569 58.385a.825.825 0 01-1.121-.322L5.4 32.721z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.69 43.893l-1.59-2.87M27.086 24.76l1.59 2.87M36.501 28.295l-.53-.956a3.292 3.292 0 00-1.96-1.566 3.25 3.25 0 00-2.483.277l-5.704 3.162a3.25 3.25 0 00-1.55 1.958 3.292 3.292 0 00.289 2.492l.53.957a3.292 3.292 0 001.96 1.566 3.25 3.25 0 002.483-.277l5.704-3.162a3.25 3.25 0 012.482-.277 3.292 3.292 0 011.96 1.566l.53.957c.423.76.527 1.657.29 2.492a3.25 3.25 0 01-1.55 1.958l-5.704 3.162a3.25 3.25 0 01-2.483.277 3.292 3.292 0 01-1.96-1.566l-.53-.956",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.606 27.784l.53.957a7.68 7.68 0 01.676 5.815 7.585 7.585 0 01-3.619 4.57l-.95.527M37.323 14.083l.53.957a7.68 7.68 0 004.574 3.654 7.585 7.585 0 005.793-.647l.95-.527M27.453 54.57l-.53-.957a7.68 7.68 0 00-4.574-3.654 7.585 7.585 0 00-5.793.647l-.95.527M52.17 40.869l-.53-.957a7.68 7.68 0 01-.676-5.815 7.585 7.585 0 013.618-4.57l.951-.527",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.65 56.677l1.722 3.105a.825.825 0 001.121.322L64.978 38.77a.825.825 0 00.322-1.121L51.253 12.308a.825.825 0 00-1.122-.322l-3.08 1.708",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53 60h4M63 60h4M60 63v4M60 53v4M5 12h4M15 12h4M12 15v4M12 5v4",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgProfits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "/img/profits.svg";
export { SvgProfits as ReactComponent };